export default __webpack_public_path__ + "static/media/Yun Hou.b49ef429.JPG";